import React from "react";

const LoadingSpinner: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center justify-center bg-gradient-to-br from-primary-50 via-white to-primary-100/50">
      <div className="text-center">
      {/*  主加载动画 */}
        <div className="relative mb-8">
          <div className="w-20 h-20 border-4 border-primary-200 rounded-full animate-spin border-t-primary-600 mx-auto"></div>
          <div className="absolute inset-0 w-20 h-20 border-4 border-transparent rounded-full animate-ping border-t-primary-400 mx-auto"></div>
        </div>

      {/*  机器人图标 */}
        <div className="mb-6">
          <div className="w-16 h-16 bg-gradient-to-br from-primary-600 to-primary-700 rounded-xl flex items-center justify-center mx-auto animate-pulse">
            <i className="fas fa-robot text-2xl text-white"></i>
          </div>
        </div>

      {/*  加载文字 */}
        <h2 className="text-xl font-semibold text-primary-900 mb-2">正在加载</h2>
        <p>LX机器人为您准备精彩内容···</p>

        {/*进度条动画*/}
        <div className="mt-6 w-64 h-1 bg-primary-200 rounded-full mx-auto overflow-hidden">
          <div className="h-full bg-gradient-to-r from-primary-500 to-primary-600 rounded-full animate-pulse"></div>
        </div>
      </div>
    </div>
  );
}

export default LoadingSpinner;
